import React, {useEffect, useState} from "react";
import {AutoComplete, Button, Col, Form, Input, message, Modal, Row, Space, Switch} from "antd";
import {CloseCircleOutlined, DeleteOutlined, EditFilled, MinusCircleFilled, PlusCircleFilled} from "@ant-design/icons";
import {apiClient} from "../../../../services/ApiClient";

const { TextArea } = Input;
const { confirm } = Modal;

export default function OrganizationSection({onSelect, value}) {
  const mapRecord = (record) => {
    record.displayName = `${record.name}`;
    return {
      key: record.id,
      value: (
        <>
          <div style={{color: '#000'}}>
            {record.name}
          </div>
          <div style={{fontSize: '0.8em'}}>
            Адрес: {record.address}
          </div>
          <div style={{fontSize: '0.8em'}}>
            Телефон: {record.phone}
          </div>
          <div style={{fontSize: '0.8em'}}>
            ОГРН: {record.ogrn}
          </div>
        </>
      ),
      record: record
    };
  };

  let [record, setRecord] = useState(value ? mapRecord(value) : null);
  let [options, setOptions] = useState([]);
  let [formVisible, setFormVisible] = useState(false);
  let [loading, setLoading] = useState(false);
  let [enableSave, setEnableSave] = useState(false);
  let [form] = Form.useForm();

  useEffect(() => {
    setRecord(value);

    let save = false;
    if(localStorage.getItem(`OrganizationSection.enableSave`) === null) {
      save = false;
    } else {
      save = localStorage.getItem('OrganizationSection.enableSave') === "true";
      if(save) {
        const rec = localStorage.getItem('OrganizationSection.record');
        if(rec) {
          setRecord(JSON.parse(rec));
        }
      }
    }
    setEnableSave(save);
  }, [value]);

  const updateEnableSave = (checked) => {
    localStorage.setItem('OrganizationSection.enableSave', String(checked));
    if(!checked) {
      localStorage.removeItem('OrganizationSection.record');
    } else if(record) {
      localStorage.setItem('OrganizationSection.record', JSON.stringify(record));
    }
    setEnableSave(checked);
  };

  const updateRecord = rec => {
    if(rec) {
      localStorage.setItem('OrganizationSection.record', JSON.stringify(rec));
    } else {
      localStorage.removeItem('OrganizationSection.record');
    }
    setRecord(rec);
    onSelect(rec);
    setOptions([]);
  };

  const search = (val) => {
    apiClient.searchDirectoryRecord('organization', val)
      .then(res => {
        if(res.success) {
          setOptions(res.records.map(e => mapRecord(e)));
        } else if(res.errorMessage) {
          message.error(res.errorMessage);
        }
      })
      .catch(err => {
        message.error("Не удалось выполнить поиск")
      });
  };

  const create = (args) => {
    setLoading(true);
    apiClient.createDirectoryRecord('organization', args)
      .then(res => {
        if(res.success) {
          form.resetFields();
          setFormVisible(false);
          setRecord(mapRecord(res.record).record);
          onSelect(res.record);
        } else if(res.errorMessage) {
          message.error(res.errorMessage);
        }
      })
      .catch(err => {
        message.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const update = (args) => {
    setLoading(true);
    apiClient.updateDirectoryRecord('organization', record.id, args)
      .then(res => {
        if(res.success) {
          form.resetFields();
          setFormVisible(false);
          setRecord(mapRecord(res.record).record);
          onSelect(res.record);
        } else if(res.errorMessage) {
          message.error(res.errorMessage);
        }
      })
      .catch(err => {
        message.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const remove = () => {
    if(!record) {
      return;
    }
    apiClient.removeDirectoryRecord('organization', record.id)
      .then(res => {
        if(res.success) {
          setRecord(null);
          setOptions([]);
          onSelect(null);
          if(formVisible) {
            form.resetFields();
          }
        } else {
          message.error("Ошибка");
        }
      })
      .catch(err => {
        message.error(err);
      });
  };

  const renderForm = () => {
    if(!formVisible) {
      return null;
    }
    if(record) {
      form.setFieldsValue({
        "name": record.name,
        "address": record.address,
        "phone": record.phone,
        "ogrn": record.ogrn,
        "okpo": record.okpo,
        "statement": record.statement,
      });
    }
    return (
      <Form form={form} layout="horizontal" style={{margin: '10px 0'}}
            labelCol={{span: 3}}
            wrapperCol={{span: 10}}
            onFinish={(args) => { record !== null && record.id > 0 ? update(args) : create(args) }}
      >
        <Form.Item
          label="Орг. перевозчик"
          name="name"
          rules={[
            {
              required: true,
              message: 'Укажите Имя',
            },
          ]}
        >
          <Input allowClear={true}/>
        </Form.Item>

        <Form.Item
          label="Адрес"
          name="address"
          rules={[
            {
              required: true,
              message: 'Укажите Адрес',
            },
          ]}>
          <Input allowClear={true}/>
        </Form.Item>

        <Form.Item
          label="Телефон"
          name="phone"
          rules={[
            {
              required: true,
              message: 'Укажите Телефон',
            },
          ]}>
          <Input allowClear={true}/>
        </Form.Item>

        <Form.Item
          label="ОГРН"
          name="ogrn"
          rules={[
            {
              required: true,
              message: 'Укажите ОГРН',
            },
          ]}>
          <Input allowClear={true}/>
        </Form.Item>

        <Form.Item
          label="форма по ОКПО"
          name="okpo"
          rules={[
            {
              required: true,
              message: 'Укажите ОКПО',
            },
          ]}>
          <Input allowClear={true}/>
        </Form.Item>

        <Form.Item
          label="Утверждение"
          name="statement"
          rules={[
            {
              required: true,
              message: 'Укажите Утверждение',
            },
          ]}>
          <TextArea rows={4} allowClear={true}/>
        </Form.Item>

        <Form.Item wrapperCol={{span: 10, offset: 3}} style={{textAlign: "right"}}>
          <Button type="primary" htmlType="submit" loading={loading}>
            Сохранить
          </Button>
        </Form.Item>
      </Form>
    );
  };

  const renderSelectedActions = () => {
    return (
      <>
        {formVisible
          ? <Button type="link" icon={<CloseCircleOutlined/>} onClick={() => setFormVisible(false)}/>
          : <Button type="link" icon={<EditFilled/>} onClick={() => setFormVisible(true)}/>}
        <Button type="link"
                style={{color: 'darkred'}}
                icon={<DeleteOutlined/>}
                onClick={() => {
                  confirm({
                    title:  "Удаление",
                    content: "Вы уверены, что хотите удалить запись?",
                    icon: <DeleteOutlined/>,
                    visible: true,
                    onOk() {
                      remove();
                    },
                  })
                }}/>

      </>
    );
  };

  const renderNotSelectedActions = () => (
    formVisible
      ? <Button type="link" icon={<MinusCircleFilled/>} onClick={() => setFormVisible(false)}/>
      : <Button type="link" icon={<PlusCircleFilled/>} onClick={() => setFormVisible(true)}/>
  );

  return (
    <>
      <Row>
        <Col span={3}>
          <h3>Организация</h3>
        </Col>
        <Col span={10}>
          <AutoComplete
            style={{width: '100%'}}
            options={options}
            onSelect={(val, opt) => { updateRecord(opt.record) }}
            onSearch={search}
            onChange={(val) => {
              if(val === undefined) {
                updateRecord(null);
                if(formVisible) {
                  form.resetFields();
                }
              } else {
                setRecord({name: val});
              }
            }}
            value={record ? record.name : ""}
            allowClear={true}
            placeholder="Искать организацию..."
          />
        </Col>
        <Col span={1}>
          <Space direction="horizontal">
            {
              record != null && record.id > 0
                ? renderSelectedActions()
                : renderNotSelectedActions()
            }
          </Space>
        </Col>
        <Col span={10} style={{textAlign: 'right'}}>
          <Switch checked={enableSave}
                  checkedChildren="Сохранять"
                  unCheckedChildren="Не сохранять"
                  style={{width: 120}}
                  onChange={(checked, event) => { updateEnableSave(checked) }}/>
        </Col>
      </Row>
      {renderForm()}
    </>
  );
}